<template>
    <div class="box-layout">
        <img src="@/assets/images/logo.png" class="w-100 mb-4" />
        <slot></slot>
    </div>
</template>

<script>
    export default {}
</script>

<style scoped type="text/css">
    .box-layout
    {
        max-width: 400px;
        width: 100%;
        margin: auto;
        margin-top: 10vh;
    }
</style>